/**
 * Armazon comun de los textos legales: terminos y condiciones, y politica de
 * privacidad. Aprobados por el cliente el 02-10-2026: se indexan y estan en
 * el sitemap.
 */
import type { ReactNode } from 'react';

import { Seo } from '../../seo/Seo';

interface DocumentoLegalProps {
  titulo: string;
  descripcion: string;
  ruta: string;
  /** Fecha desde la que rige el texto, ya escrita para leer. */
  actualizado: string;
  children: ReactNode;
}

export function DocumentoLegal({
  titulo,
  descripcion,
  ruta,
  actualizado,
  children,
}: DocumentoLegalProps) {
  return (
    <>
      <Seo titulo={titulo} descripcion={descripcion} ruta={ruta} />

      <div className="contenedor pagina">
        <article className="legal">
          <header className="encabezado-pag">
            <div>
              <h1>{titulo}</h1>
              <p className="sub">Última actualización: {actualizado}</p>
            </div>
          </header>

          {children}
        </article>
      </div>
    </>
  );
}
